import React, { useState } from "react";
import {
  FaChevronDown,
  FaIndustry,
  FaTools,
  FaBriefcase,
  FaHammer,
} from "react-icons/fa"; // Importing different icons
import Slider from "react-slick"; // Import Slider from React Slick
import s from "./Services.module.css"; // CSS Module
import Pen from "../../assets/svg/pen.jsx";
import Download from "../../assets/svg/download.jsx";
import Red from "../../assets/svg/redBackgorund.jsx";
import Blue from "../../assets/svg/blueBackgorund.jsx";
import Grey from "../../assets/svg/greyBackground.jsx";
import { transform } from "framer-motion";

const positions = [
  {
    title: "AS9100 Standardının Analizi ve Uygulama Süreçleri Desteklenmesi",
    description:
      "Bu pozisyon, AS9100 standardının analiz edilmesi ve planlanması sürecini içerir. Ayrıca, şirketlerin bu standardı kendi özel ihtiyaçlarına göre uygulamaları konusunda destek sağlanır. Hedef, havacılık ve savunma sanayii şirketlerinin kalite yönetim sistemlerinin uluslararası standartlara uygun hale getirilmesidir.",
    icon: (
      <Pen
        className={s.icon}
        style={{ color: "#4A90E2", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}>
        {" "}
        <Red />
      </div>
    ),
  },
  {
    title: "Belgelendirme Süreci ve AS9100 Uyumunun Sürdürülebilirliği",
    description:
      "Bu görev, şirketlerin AS9100 belgelendirme sürecine hazırlık yapmalarını sağlar. Ayrıca, bu uyumun sürdürülebilirliğini sağlamak için gereken sürekli izleme ve iyileştirme adımlarını içerir. Amaç, kalite yönetim sistemlerinin uzun vadeli başarı için stabilize edilmesidir.",
    icon: (
      <Download
        className={s.icon}
        style={{ color: "#F39C12", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, bottom: -5, zIndex: 1 }}>
        {" "}
        <Blue />
      </div>
    ),
  },
  {
    title:
      "Havacılık ve Savunma Sanayii Kalite Yönetim Sistemleri Gerekliliklerinin İmplementasyonu",
    description:
      "Havacılık ve savunma sanayii firmalarının özel kalite yönetim sistemi gerekliliklerinin uygulanması, bu endüstrinin karmaşık standartlarını karşılamak amacıyla kalite sistemlerinin optimize edilmesini sağlar. Bu süreç, kalite süreçlerinin iyileştirilmesi ve sistematik bir şekilde güçlendirilmesine odaklanır.",
    icon: (
      <FaBriefcase
        className={s.icon}
        size={50}
        style={{ color: "#1ABC9C", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", left: 45, top: -6, zIndex: 1 }}>
        {" "}
        <Grey />
      </div>
    ),
  },
  {
    title: "Kalite Doküman Yönetimi Sistemi Kurulumu",
    description:
      "Kalite dokümanlarının etkin bir şekilde yönetilmesi, bir organizasyonun işleyişi için kritik öneme sahiptir. Bu süreç, kalite belgelerinin düzenli ve erişilebilir bir şekilde yönetilmesi için gerekli sistemlerin kurulmasını içerir, böylece belge kontrol süreçleri iyileştirilir.",
    icon: (
      <FaHammer
        className={s.icon}
        size={50}
        style={{ color: "#E74C3C", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}>
        {" "}
        <Red />
      </div>
    ),
  },
  {
    title: "Operasyonel Mükemmellik Danışmanlığı (6 Sigma Projeleri)",
    description:
      "Bu pozisyon, havacılık ve savunma sanayii sektörlerinde operasyonel mükemmellik sağlamak için 6 Sigma projelerinin uygulanmasını içerir. Amaç, süreçleri optimize etmek ve hata oranlarını minimuma indirmektir. 6 Sigma metodolojisi, organizasyonların verimliliklerini artırmalarına yardımcı olur.",
    icon: (
      <FaIndustry
        className={s.icon}
        size={50}
        style={{ color: "#4A90E2", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, bottom: -5, zIndex: 1 }}>
        {" "}
        <Blue />
      </div>
    ),
  },
  {
    title: "Sektörel Tecrübe Aktarımı ve Eğitimler",
    description:
      "Sektörel tecrübe aktarımı ve eğitimler, çalışanların ve yöneticilerin güncel sektör bilgilerine sahip olmalarını sağlar. Bu eğitimler, endüstri standartları, kalite yönetimi ve yeni teknolojiler hakkında bilgi vererek organizasyonların performansını artırmayı hedefler.",
    icon: (
      <FaBriefcase
        className={s.icon}
        size={50}
        style={{ color: "#1ABC9C", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", left: 45, top: -6, zIndex: 1 }}>
        {" "}
        <Grey />
      </div>
    ),
  },
  {
    title: "Tedarikçi Geliştirme Programları ve Stratejiler",
    description:
      "Bu görev, tedarikçilerin performansını artırmak için geliştirme programları ve stratejiler oluşturmayı içerir. Tedarikçi kalitesinin iyileştirilmesi, daha verimli tedarik zincirlerinin kurulmasını sağlayarak organizasyonun genel başarıya katkı sağlar.",
    icon: (
      <FaTools
        className={s.icon}
        size={50}
        style={{ color: "#F39C12", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, bottom: -5, zIndex: 1 }}>
        {" "}
        <Blue />
      </div>
    ),
  },
  {
    title: "Fiziksel ve Sanal Server Kurulumu",
    description:
      "İşletmenize özel fiziksel ve sanal sunucu çözümleri sunuyoruz. Güvenli, yüksek performanslı ve ölçeklenebilir altyapılar kurarak verilerinizi kesintisiz ve etkin bir şekilde yönetmenizi sağlıyoruz.",
    icon: (
      <FaTools
        className={s.icon}
        size={50}
        style={{ color: "#F39C12", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, bottom: -5, zIndex: 1 }}>
        {" "}
        <Blue />
      </div>
    ),
  },
  {
    title: "Web Tabanlı ve Mobil Uygulama Geliştirme ",
    description:
      "Modern teknolojilerle web ve mobil uygulamalar geliştiriyoruz. Kullanıcı dostu, hızlı ve güvenli çözümlerle iş süreçlerinizi dijitalleştirip müşteri deneyimini iyileştiriyoruz.",
    icon: (
      <FaTools
        className={s.icon}
        size={50}
        style={{ color: "#F39C12", marginBottom: "16px" }}
      />
    ),
    backgorund: (
      <div style={{ position: "absolute", right: 0, bottom: -5, zIndex: 1 }}>
        {" "}
        <Blue />
      </div>
    ),
  },
];

const Services = () => {
  const [flippedCardIndex, setFlippedCardIndex] = useState(null);
  const [flippedCardIndices, setFlippedCardIndices] = useState([]);

  const handleFlip = (index) => {
    setFlippedCardIndices((prevIndices) => {
      if (prevIndices.includes(index)) {
        // Eğer index zaten dizide varsa, kaldır
        return prevIndices.filter((i) => i !== index);
      } else {
        // Eğer index dizide yoksa, ekle
        return [...prevIndices, index];
      }
    });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2, // Mobilden büyük ekranlarda 2 kart gösterilebilir
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  console.log(flippedCardIndex);
  return (
    <div id="services" className={s.container}>
      <div className={s.main_title_container}>
        <h1 className={s.main_title}>Hizmetlerimiz</h1>
      </div>
      <div className={s.content}>
        <Slider {...settings}>
          {positions.map((position, index) => (
            <div    onMouseEnter={() => handleFlip(index)}
            onMouseLeave={() => handleFlip(index)}                    onClick={() => handleFlip(index)}
            key={index} className={s.main_card}>
              <div
                className={`${s.card_inner} ${
                  flippedCardIndices.includes(index) ? s.flipped : ""
                }`}
                style={{
                  transform: flippedCardIndices.includes(index)
                    ? "rotateY(180deg)"
                    : "none",
                }}
              >
                {/* Ön Yüz */}
                <div className={`${s.card_front} ${s.card_face}`}>
                  {position.backgorund}
                  {position.icon}
                  <div className={s.card_info}>
                    <h2>{position.title}</h2>
                  </div>
                  <button
                    className={s.more_button}
                    onClick={() => handleFlip(index)}
                  >
                    Daha Fazla Bilgi
                  </button>
                </div>
                {/* Arka Yüz */}
                <div className={`${s.card_back} ${s.card_face}`}>
                  <p>{position.description}</p>
                  <button
                    className={s.more_button}
                    onClick={() => handleFlip(index)}
                  >
                    Daha Az Bilgi
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Services;
